// extracted by mini-css-extract-plugin
export var createdDate = "_ja-1";
export var divider = "_ja-2";
export var headerDivider = "_ja-3";
export var messagesCard = "_ja-0";
export var messagesContainer = "_ja-6";
export var messagesContainerWrapper = "_ja-4";
export var showLeftPanelButton = "_ja-8";
export var topButtons = "_ja-7";
export var withPadding = "_ja-5";